import { render, staticRenderFns } from "./DinvoiceIndex.vue?vue&type=template&id=0cd444d6&scoped=true"
import script from "./DinvoiceIndex.vue?vue&type=script&lang=js"
export * from "./DinvoiceIndex.vue?vue&type=script&lang=js"
import style0 from "./DinvoiceIndex.vue?vue&type=style&index=0&id=0cd444d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd444d6",
  null
  
)

export default component.exports